import { Component, ElementRef, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { Observable, of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { TaskDTO, InboxDTO, OrganizationalUnitDTO, UserDTO, SearchSelectionResultDTO } from '../../../api/plyca-dtos';
import { ActionParameterDefinitionDTO } from '../../../api/plyca-dtos-v2';
import { FormConfig } from '../../../components/forms/form.objects';
import { SearchSettingDTOModal, searchGenericComponent } from '../../../components/search/searchGeneric.component';
import { InboxUsersComponent } from '../../../dossiers/audit/inboxusers.component';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { WorkAssignManagerDTO } from '../model/assignManager.model';
import { tasksListComponent } from '../../tasksList.component';
import { PaginationDTO } from '../../../api/PaginationModel';



export class AssignManagerModel {
  dto: WorkAssignManagerDTO;
  ui: {
    documentClassAplication?: string
    // taskProfile?: number,
    lockedOrganizationalUnit?: boolean,
    organizationalUnit: OrganizationalUnitDTO,
    application?: string,
    selectCheckFinal?: boolean,
    profile?: string,
    existsProfile?: boolean,
    edition?: boolean;
  };
}

@Component({
  templateUrl: './assignManager.template.html'
  // templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html'
})
export class AssignManagerComponent extends BaseFormComponent<WorkAssignManagerDTO, AssignManagerModel> implements OnInit {
  // private contract: ContractDTO;

  expandedRows: {} = {};
  constructor(
    elem: ElementRef,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super(elem);
  }

  ngOnInit(): void {
    /*  if (this.task && this.task.work && this.task.work.contract) {
        console.log('INVOCACION DE RECEIPT DESDE TAREA', this.task);
        //this.workRegisterContractModification = this.task.work;
        //this.identifier = this.task.work.registerContractModification.identifier;
        this.contract = this.task.work.contract;
      }*/
    super.ngOnInit();
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    // super.configureFormConfig (formConfig);
    // formConfig.showValidations = true;
    // formConfig.isModalWindow = true;
    // formConfig.windowHash = this.windowHash;

    formConfig.functions.push({
      identifier: 'showInbox',
      fn: this.showInbox.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeselectedUserProfile',
      fn: this.onChangeselectedUserProfile.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeselectedUser',
      fn: this.onChangeselectedUser.bind(this)
    });
    // formConfig.readonly = this.readonly;
    return of(formConfig);
  }

  getFormSettingURL(): string {
    return 'assignManager/assignManagerSettings.json';
  }
  getServiceURL(): string {

    //  userAPI/v1/tasks/{taskId}/assignmanager/
    // let url =  this._configuration.URL_BASE + serviceUrl + 'validations/' + validation;
    // public URL_BASE = this.SERVER_URL + this.ApiUrl;
    // private ApiUrl = 'plyca/';
    // return undefined;

    // @RequestMapping("/userAPI/v1/tasks/{taskId}/contractModification")
    // public CONTRACT_MODIFICATIONS_SERVICE_URL =  this.UserApiUrl + this.ApiVersion + 'contractModifications/';
    // private UserApiUrl = 'userAPI/';
    // this.configuration.UserApiUrl
    return this.configuration.TAKS_SERVICE_URL + this.task.identifier + '/assignmanager/';

  }
  getObjectIdentifier() {
    return undefined;
  }
  dtoToModel(dto: WorkAssignManagerDTO): Observable<AssignManagerModel> {
    let model = new AssignManagerModel();
    model.dto = this.task['work'];

    // let users = this.task.work.users;

    /*
      users: Array<UserDTO>;
  definitiveInbox: boolean;
  finalInbox: InboxDTO;
  selectedInbox: InboxDTO;
  */

    model.ui = {
      selectCheckFinal: false,
      existsProfile: false,
      lockedOrganizationalUnit: true,
      profile: '',
      edition: true,
      application: '',
      organizationalUnit: null
    };

    if (this.task && this.task.work) {

      model.ui.documentClassAplication = this.task.division.documentClass.application;
      model.ui.organizationalUnit = this.task.lockedBy.organizationalUnit;
      model.ui.application = this.task.division.project.application;

      if (this.task.work.context && this.task.work.context.configurations) {
        if (this.task.work.context.configurations['selectCheckFinal']) {
          // definitiveInbox
          model.ui.selectCheckFinal = this.task.work.context.configurations['selectCheckFinal'].value;
        }
        if (this.task.work.context.configurations['lockedOrganizationalUnit']) {
          // definitiveInbox
          model.ui.lockedOrganizationalUnit = this.task.work.context.configurations['lockedOrganizationalUnit'].value;
        }
        if (this.task.work.context.configurations['requiredProfile']) {
          model.ui.profile = this.task.work.context.configurations['requiredProfile'].value;
          if (model.ui.profile != null && model.ui.profile !== '') {
            model.ui.existsProfile = true;
          }
          /*
          {
            "id": "requiredProfile",
            "descriptionKey": "AssignManager.groupe.data.requiredProfile",
            "tooltipText": "AssignManager.groupe.data.requiredProfile",
            "jsonField": "ui.profile",
            "type": "TEXT",
            "editable": "false",
            "visibility": "false",
            "columnStyle": {
              "width": "10%"
            }
          },*/
        }
      }
    }

    /*
      let parametersURL: ActionParameterDefinitionDTO[] = [];

        let param = new ActionParameterDefinitionDTO();
        param.identifier = 'BUZON.USUARIOSNOBLOQUEADOS';
        param.value = 'true';
        parametersURL.push(param);


        let param1 = new ActionParameterDefinitionDTO();
        param1.identifier = 'PERFILBUZON.APLICACION';
        param1.value = this.task.division.documentClass.application;
        parametersURL.push(param1);


        let param2 = new ActionParameterDefinitionDTO();
        param2.identifier = 'PERFILBUZON.PERID';
        param2.value = this.task.profile.identifier;
        parametersURL.push(param2);


        let param3 = new ActionParameterDefinitionDTO();
        param3.identifier = 'BUZON.EXCLUIRBUZONESUSUARIO';
        param3.value = 'true';
        parametersURL.push(param3);


        let param4 = new ActionParameterDefinitionDTO();
        param4.identifier = 'PERFILBUZON.USUARIO';
        param4.value = this.user.identifier;
        parametersURL.push(param4);

        let param5 = new ActionParameterDefinitionDTO();
        param5.identifier = 'ORGANISMO.RUTA';
        param5.value = this.user.organizationalUnit.identifier;
        parametersURL.push(param5);

        if (this.task.type === TaskTypeDTO.TIPO_FIRMA
          || this.task.type === TaskTypeDTO.TIPO_FIRMA_MASIVA) {
          let param6 = new ActionParameterDefinitionDTO();
          param6.identifier = 'USUARIO.TIENEFIRMA';
          param6.value = 'true';
          parametersURL.push(param6);
        }
    */




    /*  model.ui.contractModificationType = this.translate.instant('Certification.detail.contractModificationType.value');
      if (this.task && this.task.work) {
        if (this.task.work.context && this.task.work.context.configurations) {
          if (this.task.work.context.configurations['screenMode']) {
            if (this.task.work.context.configurations['screenMode'].value
            == 'RECTIFICA' || this.task.work.context.configurations['screenMode'].value == 'ANULA') {
              model.ui.isModeError = true;
              model.ui.edition = false;
            }
          }
          if (this.task.work.context.configurations['isREPLYCATask'].value == '1') {
            model.ui.isREPLYCATask = true;
          }

          if (this.task.work.context.configurations['isProjectReplyca'].value == '1') {
            model.ui.isProjectReplyca = this.task.work.context.configurations['isProjectReplyca'].value;
          }
        }
        if (model.dto.document && model.dto.document.relatedDocuments) {
          let relatedDocuments = model.dto.document.relatedDocuments;
          for (let i in relatedDocuments) {
            if (relatedDocuments[i]) {
              if (relatedDocuments[i].visible) {
                model.ui.visibleRelatedReceipts.push(relatedDocuments[i]);
              } else {
                model.ui.notVisibleRelatedReceipts.push(relatedDocuments[i]);
              }
            }
          }
        }
        if (model.ui.visibleRelatedReceipts
          && model.ui.visibleRelatedReceipts[0]
          && model.ui.visibleRelatedReceipts[0].document) {
          model.ui.existsRelatedReceipt = true;
        }
      }*/

    const thisRef = this;
    model.dto.users.forEach(function (user) {
      thisRef.expandedRows[user.identifier] = true;
    });

    return of(model);
  }

  protected getTask(): TaskDTO {
    this.modelToDTO(this.model);
    return this.task;
  }

  modelToDTO(model: AssignManagerModel): WorkAssignManagerDTO {
    // OJO, el model puede ser un clonado del modelo de la pantalla y por lo tanto
    // los cambios realizados no se trasladan al objeto task.work (p.ej; cuando se llama a saveIfValid() sin el parametro modelo y es tarea)
    // el problema porque el parametro model es un clonado del dto de la pantalla
    model.dto.finalInbox = null;
    if (model.ui.selectCheckFinal) {
      model.dto.finalInbox = model.dto.selectedInbox;
    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'AssignManager.detail.title';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    // TODO
    //    headerInfo.project = this.model.dto.division.project;
    return headerInfo;
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addAction(
        'General.search.text',
        'fas fa-search',
        'btn-primary',
        true
      ),
      () => {
        if (this.model.ui.existsProfile) {
          this.openUserWithProfileSearch();
        } else {
          this.openUserSearch();
        }
      });
    this.addBackAction();
  }

  showInbox(param?: any) {
    // si viene del formulario llega como parametro el model
    // si se invoca desde la tabla de buzones llegara un objeto inboxDto
    let _inbox: InboxDTO;
    if (param.dto) {
      let model = new AssignManagerModel();
      model.dto = this.task['work'];
      if (model.dto.selectedInbox) {
        _inbox = model.dto.selectedInbox;
      }
    } else {
      _inbox = param;
    }
    if (_inbox) {
      let config: DynamicDialogConfig = {
        header: this.translate.instant('Audit.UsersTaskAccess.title') + ': (' + _inbox.identifier + ') ' + _inbox.name + '.',
        width: '60%',
        style: { 'max-height': '60%' },
        styleClass: 'helpStyle'
      };
      // config['taskId'] = element.swIdTask;
      config['inboxId'] = _inbox.identifier;
      // config['inboxDescription'] = inbox.name;
      const ref = this.dialogService.open(InboxUsersComponent, config);
      this.subscribe(ref.onClose);
    }
  }

  selectInbox(inbox: InboxDTO) {
    this.model.dto.selectedInbox = inbox;
    // Se le pasa el modelToDTO para evitar problema descrito en ese metodo
    this.subscribe(this.saveIfValid(true, this.modelToDTO(this.model)));/*.pipe(
      tap((updatedTask: TaskDTO) => {
        this.model.dto = updatedTask['work'];
      }
      )
    )
    );*/
  }

  public onChangeselectedUserProfile(model: any, changes?: any) {
    if (changes.newValue) {
      let user: UserDTO = changes.newValue;
      this.selectUser(user);
    }
  }

  public onChangeselectedUser(model: any, changes?: any) {
    if (changes.newValue) {
      let user: UserDTO = changes.newValue;
      this.selectUser(user);
    }
  }

  private selectUser(user: UserDTO) {
    this.model.dto.users = new Array<UserDTO>();
    if (user != null) {
      this.model.dto.users.push(user);
    }
  }

  public openUserSearch() {

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param0 = new ActionParameterDefinitionDTO();
    param0.identifier = 'USUARIO.BLOQUEADO';
    param0.value = 'N';
    parametersURL.push(param0);


    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'ORGANISMO.RUTA';
    param2.value = this.model.ui.organizationalUnit.identifier;
    parametersURL.push(param2);

    // Tenemos en cuenta el aplicativo aunque el applet en este caso no lo considere
    let param3 = new ActionParameterDefinitionDTO();
    param3.identifier = 'PERFILUSUARIO.APLICACION';
    param3.value = this.model.ui.application;
    parametersURL.push(param3);


    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'ASIGNAR_ENCARGADO_USUARIOS_SIN_PERFIL',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Buscador de usuarios',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);

    this.subscribe(ref.onClose,
      (searchSelectionResult: SearchSelectionResultDTO) => {
        this.selectUser(searchSelectionResult.result);
      },
      (error) => {
        console.log(error);
      });
  }

  /*

    {
      "id": "selectedUser",
      "description": "Buscador de usuarios",
      "jsonField": "selectedUser",
      "type": "SEARCH",
      "idBuscador": "ASIGNAR_ENCARGADO_USUARIOS_SIN_PERFIL",
      "parameters": [
        {
          "identifier": "USUARIO.BLOQUEADO",
          "value": "'N'"
        },
        {
          "identifier": "ORGANISMO.RUTA",
          "value": "this.model.ui.organizationalUnit.identifier"
        }
      ],
      "autoSearch": true,
      "visibility": "!this.model.ui.existsProfile",
      "onChangeFunction": "onChangeselectedUser",
      "fieldStyle": "col-sm-12  col-md-8",
      "fieldStyle_old": "col-6"
    },*/

  public openUserWithProfileSearch() {

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param0 = new ActionParameterDefinitionDTO();
    param0.identifier = 'USUARIO.BLOQUEADO';
    param0.value = 'N';
    parametersURL.push(param0);

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PERFIL.PERID';
    param1.value = this.model.ui.profile;
    parametersURL.push(param1);


    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'ORGANISMO.RUTA';
    param2.value = this.model.ui.organizationalUnit.identifier;
    parametersURL.push(param2);

    let param3 = new ActionParameterDefinitionDTO();
    param3.identifier = 'PERFILUSUARIO.APLICACION';
    param3.value = this.model.ui.application;
    parametersURL.push(param3);


    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'ASIGNAR_ENCARGADO_USUARIOS_CON_PERFIL',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Buscador de usuarios',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);

    this.subscribe(ref.onClose,
      (searchSelectionResult: SearchSelectionResultDTO) => {
        this.selectUser(searchSelectionResult.result);
      },
      (error) => {
        console.log(error);
      });
  }




  inboxTasks(inbox: InboxDTO) {

    let title = 'ControlPanel.inboxs.actions.userTasks';
    let config: DynamicDialogConfig = {
      header: this.translate.instant(title) + ' ' + inbox.name + ' [' + inbox.identifier + ']',
      width: '60%',
      styleClass: 'viewStyle'

    };


    let params: { [param: string]: any } = {};
    params['page'] = 0;
    params['size'] = 9999;
    params['expand'] = 'expansionSet:client_tasks';


    params['selectedInboxId'] = inbox.identifier;

    /* this.isModalWindow = true;
     this.windowHash = generateRandomIdentifier();
     this.waitService.startWaiting();*/
    let t;
    this.waitService.startWaiting();
    this.subscribe(
      this.plycaService.query(
        this.configuration.TAKS_SERVICE_URL, params
      ).pipe(
        tap((param: PaginationDTO<TaskDTO>) => {
          t = param ? param.content : [];
          config['readonly'] = true;
          config['inboxId'] = inbox.identifier;
          config['list'] = t;

          const dialog = this.dialogService.open(tasksListComponent, config);
          dialog.onClose.subscribe(person => {



          });

        }),
        catchError(
          (err) => {

            this.plycaErrorHandler.showServerError(err);
            this.waitService.cancelWaiting();

            return of(true);
          }),
        finalize(() => {

        })
      )
    );



  }
}
